import React, { useEffect, useState } from "react"
import { fetchVariables } from "../api/templatesApi"

// Renders a live, channel-styled preview of the template body/subject by
// substituting variables with their sample values (client-side, instant).
// {{ key }} tokens with no known sample are left visible so the author notices.
export function MessagePreview({ channel, category, subject, body }) {
  const [samples, setSamples] = useState({})

  useEffect(() => {
    if (!category) return
    fetchVariables(category)
      .then((groups) => {
        const flat = {}
        Object.values(groups).forEach((vars) => vars.forEach((v) => { flat[v.key] = v.sample }))
        setSamples(flat)
      })
      .catch(() => setSamples({}))
  }, [category])

  const render = (text) =>
    (text || "").replace(/\{\{\s*([\w.]+)\s*(\|[^}]*)?\}\}/g, (match, key) =>
      samples[key] !== undefined ? samples[key] : match
    )

  const renderedBody = render(body)
  const renderedSubject = render(subject)

  if (channel === "email") {
    return (
      <div className="overflow-hidden rounded-lg border border-slate-200 bg-white">
        <div className="border-b border-slate-100 bg-slate-50 px-4 py-2">
          <p className="text-[11px] text-slate-400">Subject</p>
          <p className="text-[13px] font-medium text-slate-800">{renderedSubject || "—"}</p>
        </div>
        <div className="whitespace-pre-wrap px-4 py-3 text-[13px] leading-relaxed text-slate-700">
          {renderedBody || "Your message preview will appear here."}
        </div>
      </div>
    )
  }

  // WhatsApp / SMS — chat bubble.
  const bubble =
    channel === "whatsapp"
      ? "bg-emerald-50 border-emerald-100"
      : "bg-sky-50 border-sky-100"

  return (
    <div className="rounded-lg bg-slate-100 p-4">
      <div className={`max-w-[85%] rounded-2xl rounded-tl-sm border px-3.5 py-2.5 ${bubble}`}>
        <p className="whitespace-pre-wrap text-[13px] leading-relaxed text-slate-800">
          {renderedBody || "Your message preview will appear here."}
        </p>
      </div>
    </div>
  )
}
